import { createSelector } from "reselect";

const selfState = (state) => state;
export const authSelector = createSelector(selfState, (state) => state.auth);
